import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { first } from 'rxjs';

export interface EmployeeModel {
    id: string;
    name: string;
    url: string;
    createdAt: number | Date;
    interactions: number;
    title: string;
    firstName: string;
    lastName: string;
    mentionCount?: number;
    mentionCountLastMonth?: number;
}

@Component({
    selector: 'employee-data',
    templateUrl: './employee-data.component.html',
    styleUrls: ['./employee-data.component.sass']
})
export class EmployeeDataComponent implements OnChanges,OnInit {
    @Input() employeeList: EmployeeModel[] = [];
    @Input() count: number = 0;
    @Output() pageChange = new EventEmitter<number>();
    @Output() editEmployee = new EventEmitter<EmployeeModel>();
    @Output() deleteEmployee = new EventEmitter<EmployeeModel>();

    displayedColumns: string[] = ['NAME','TITLE', 'TAPCARD URL', 'INTERACTIONS','MENTIONS','LAST MONTH MENTIONS','CREATED', 'ACTIONS'];
    dataSource = new MatTableDataSource<EmployeeModel>([]);
    page = 0;
    pageSize = 10;
    collectionSize = 0;

    ngOnInit(): void {
        this.dataSource.data = this.employeeList;
        this.collectionSize = this.count;
    }

    ngOnChanges(changes: SimpleChanges) {        
        if (changes.employeeList) {
            this.dataSource.data = changes.employeeList.currentValue || [];
        }
        if (changes.count) {
            this.collectionSize = changes.count.currentValue || 0;            
        }
    }

    onEdit(e: EmployeeModel, event: Event) {
        event.stopPropagation();
        console.log(e);
        
        this.editEmployee.emit(e);
    }

    onDelete(e: EmployeeModel, event: Event) {
        event.stopPropagation();
        Swal.fire({
            title: 'Delete Employee',
            text: `Are you sure you want to delete employee ${e.name}`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete employee!',
            cancelButtonText: 'Cancel',
        }).then(result => {
            if (result.value) {
                this.deleteEmployee.emit(e);
            }
        })
    }
    onPageChange(page: number) {
        this.page = page
        this.pageChange.emit(this.page - 1);
    }
}